import styled from 'styled-components';

import { ScrollableContainer as CoreScrollableContainer } from '@web/components/ScrollableContainer/ScrollableContainer';

export const ScrollableContainer = styled(CoreScrollableContainer)`
  margin: 20px 0;
`;

export const UserList = styled.ul`
  padding: 0;
  list-style-type: none;
`;

export const UserListItem = styled.li`
  display: block;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnGray};
  padding: 10px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverBrand};

    span {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const EmptySearchResultsWrapper = styled.div`
  margin: 40px auto;
  text-align: center;
`;

export const EmptySearchMessage = styled.div`
  margin-top: 20px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray};
`;
